<div class="modal-header"
  [ngClass]="cssClass">
  <button *ngIf="!hideCloseButton"
    type="button"
    class="close"
    data-dismiss="modal"
    [id]="id+'-close-button'">
    <span class="sr-only">Close</span>
  </button>
  <ng-content></ng-content>
</div>
